import { render, staticRenderFns } from "./ShowFormWrap.vue?vue&type=template&id=f28f8862&scoped=true&"
import script from "./ShowFormWrap.vue?vue&type=script&lang=ts&"
export * from "./ShowFormWrap.vue?vue&type=script&lang=ts&"
import style0 from "./ShowFormWrap.vue?vue&type=style&index=0&id=f28f8862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28f8862",
  null
  
)

export default component.exports